module.exports = __webpack_public_path__ + "322df65c896c315fb01c377ea8790b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/Assets/logos.png
// module id = 1372
// module chunks = 0